import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import styles from './user-banner.module.css';

type Props = {
    maxUsers: string;
    enabledUsers: string;
};

export function UsersBanner(props: Props) {
    const getNoun = (count: string) => (count === '1' ? 'user' : 'users');

    return (
        <div className={styles.container}>
            <FlashBanner type='info' hasBorder={true}>
                <div className='flex justify-sb align-center full-width'>
                    <div className='flex flex-dir-col'>
                        <Body size='large'>Flexible, friendly pricing</Body>
                        <Body color='light'>
                            You have {props.enabledUsers} sales {getNoun(props.enabledUsers)}. Your
                            billing plan is for {props.maxUsers} {getNoun(props.maxUsers)}.
                        </Body>
                    </div>
                    {/* @ts-expect-error */}
                    <Link as={RoutedLink} to='/setup/billing/sales' variant='primary'>
                        Update billing info
                    </Link>
                </div>
            </FlashBanner>
        </div>
    );
}
